import SwiperCarousel from 'utils/swiper-carousel';

export default (element) => {
  const comparisonSlider = element.querySelector(
    '[data-product-comparison-slider]',
  );

  if (!comparisonSlider) return;

  const init = () => {
    // eslint-disable-next-line no-new
    new SwiperCarousel(comparisonSlider, {
      slidesPerView: "auto",
      slidesOffsetBefore: 0,
      centeredSlides: true,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: element.querySelector('.next'),
        prevEl: element.querySelector('.prev'),
      },
      loop: false,
      spaceBetween: 10,
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesOffsetBefore: 40,
        },
      },
    });

    return comparisonSlider;
  };

  init();
};
